import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor,
} from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable, catchError, throwError, finalize } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class IntercptorService implements HttpInterceptor {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  private extractErrorMessage(error: HttpErrorResponse): string {
    const payload = error?.error;

    if (typeof payload === 'string' && payload.trim().length > 0) {
      return payload;
    }

    if (payload && typeof payload === 'object') {
      if (
        typeof payload.message === 'string' &&
        payload.message.trim().length > 0
      ) {
        return payload.message;
      }

      if (
        typeof payload.error === 'string' &&
        payload.error.trim().length > 0
      ) {
        return payload.error;
      }
    }

    if (typeof error.message === 'string' && error.message.trim().length > 0) {
      return error.message;
    }

    if (error.status) {
      return `Request failed (${error.status} ${error.statusText || 'Error'})`;
    }

    return 'An unexpected error occurred!';
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const clonedRequest = request.clone();

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        // Don't treat successful status codes (2xx) as errors even if parsing fails
        if (error.status >= 200 && error.status < 300) {
          // For 200-299 status codes, just return the error (not really an error for user)
          return throwError(() => error);
        }

        const errorMessage = this.extractErrorMessage(error);

        // eslint-disable-next-line no-console
        console.error('HTTP error', {
          url: error.url,
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          payload: error.error,
        });

        if (isPlatformBrowser(this.platformId)) {
          import('sweetalert2').then((Swal) => {
            Swal.default.fire({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
            });
          });
        }

        return throwError(() => error);
      }),

      finalize(() => {
        if (isPlatformBrowser(this.platformId)) {
          import('sweetalert2').then((Swal) => {
            if (Swal.default.isLoading()) {
              Swal.default.close();
            }
          });
        }
      }),
    );
  }
}
